// 공유 컴포넌트(모달, 위젯 등) 번역
const components = {
  dailyReport: {
    loading: '일일보고서를 불러오는 중...',
    fetchError: '일일보고서 데이터를 불러오지 못했습니다.',
    retry: '다시 시도',
    close: '닫기',
    title: '일 일 보 고 서',
    subtitle: 'Daily Production Report',
    reportDate: '보고일자',
    category: '구분',
    author: '작성자',
    createdAt: '작성일시',
    section1: '1. 설비 현황 (당일 집계)',
    section2: '2. 생산 실적',
    section3: '3. OEE 지표 분석',
    section4: '4. 종합 분석 및 제언',
    colItem: '항목',
    colQtyRatio: '수량/비율',
    colQty: '수량',
    colUnit: '단위',
    colNote: '비고',
    totalEquipment: '전체 설비수',
    totalEquipmentNote: '등록된 총 설비 수',
    avgOperationRate: '당일 평균 가동률',
    avgOperationRateNote: '당일 종합 가동률',
    totalShots: '당일 총 샷 수',
    totalShotsNote: '전체 사출 횟수',
    alarmCount: '알람 발생 건수',
    alarmCountNote: '당일 총 알람',
    goodProduction: '양품 생산량',
    goodProductionNote: '당일 양품',
    defectCount: '불량 수',
    defectCountNote: '당일 불량',
    totalProduction: '총 생산량',
    totalProductionNote: '양품 + 불량',
    energyUsage: '에너지 사용량',
    energyUsageNote: '전력 사용량',
    unitDae: '대',
    unitPercent: '%',
    unitTimes: '회',
    unitCount: '건',
    unitPiece: '개',
    oeeIndicator: '지표',
    oeeValue: '수치',
    oeeProgress: '진행률',
    oeeRating: '평가',
    availability: '가용성 (Availability)',
    performance: '성능 (Performance)',
    quality: '품질 (Quality)',
    overallOee: '종합 OEE',
    ratingGood: '양호',
    ratingAverage: '보통',
    ratingNeedsImprovement: '개선필요',
    ratingExcellent: '우수',
    oeeFormula: '* OEE = 가용성 × 성능 × 품질',
    pdfGenerating: 'PDF 생성 중...',
    pdfSave: 'PDF로 저장',
    pdfFailed: 'PDF 생성에 실패했습니다. 다시 시도해주세요.',
    autoFooter: '본 보고서는 자동으로 생성되었습니다.',
    fileName: '일일보고서_{category}_{date}.pdf',
  },
  weeklyReport: {
    loading: '주간보고서를 불러오는 중...',
    fetchError: '주간보고서 데이터를 불러오지 못했습니다.',
    retry: '다시 시도',
    close: '닫기',
    title: '주 간 보 고 서',
    subtitle: 'Weekly Production Report',
    reportDate: '보고일자',
    category: '구분',
    author: '작성자',
    createdAt: '작성일시',
    section1: '1. 설비 현황 (주간 집계)',
    section2: '2. 생산 실적 (주간 집계)',
    section3: '3. OEE 지표 분석 (주간 평균)',
    section4: '4. 종합 분석 및 제언 (주간)',
    avgOperationRate: '주간 평균 가동률',
    avgOperationRateNote: '주간 종합 가동률',
    totalShots: '주간 총 샷 수',
    alarmCountNote: '주간 총 알람',
    goodProductionNote: '주간 양품',
    defectCountNote: '주간 불량',
    pdfFailed: 'PDF 생성에 실패했습니다. 다시 시도해주세요.',
    fileName: '주간보고서_{category}_{startDate}_{endDate}.pdf',
  },
  monthlyReport: {
    loading: '월간보고서를 불러오는 중...',
    fetchError: '월간보고서 데이터를 불러오지 못했습니다.',
    retry: '다시 시도',
    close: '닫기',
    title: '월 간 보 고 서',
    subtitle: 'Monthly Production Report',
    yearMonth: '{year}년 {month}월',
    reportDate: '보고일자',
    category: '구분',
    author: '작성자',
    createdAt: '작성일시',
    section1: '1. 설비 현황 (월간 집계)',
    section2: '2. 생산 실적 (월간 집계)',
    section3: '3. OEE 지표 분석 (월간 평균)',
    section4: '4. 종합 분석 및 제언 (월간)',
    avgOperationRate: '월간 평균 가동률',
    avgOperationRateNote: '월간 종합 가동률',
    totalShots: '월간 총 샷 수',
    alarmCountNote: '월간 총 알람',
    goodProductionNote: '월간 양품',
    defectCountNote: '월간 불량',
    pdfFailed: 'PDF 생성에 실패했습니다. 다시 시도해주세요.',
    fileName: '월간보고서_{category}_{year}년{month}월.pdf',
  },
  monitoringWatch1: {
    cols: {
      moldClose: '형폐',
      moldProtect: '금형보호',
      highPressure: '고압',
      moldOpen: '형개',
      injectionComplete: '사출완료',
      cycleTime: '행정시간',
      extrusion: '압출',
      moldOpenComplete: '형개완료',
      maxInjectionPressure: '사출최대압',
      holdingPressure: '사출보압',
      holdingTransfer: '보압전환',
      cushionAmount: '쿠션양',
      injectionStart: '사출시작',
      metering: '계량',
      suckbackTime: '석백시간',
    },
  },
  monitoringWatch2: {
    cols: {
      no: 'No.',
      shotCount: '샷카운트',
      cycleTime: '사이클타임',
      injHoldTime: '보압시간',
      chargeTime: '계량시간',
      injStartPosi: '사출시작',
      turnPosi: '보압시작',
      injEndPosi: '쿠션량',
      fetchTime: '취출시간',
    },
  },
  lstmDefect: {
    sectionAttention: '시간 구간별 Attention Weight 분석',
    sectionFactor: '불량 원인 인자 중요도',
    sectionParamTrend: '주요 파라미터 변화 추이 (최근 50샷)',
    sectionRadar: '파라미터 상태 비교',
    sectionRecommendations: '공정 튜닝 추천값',
    sectionConfidence: '모델 예측 신뢰도',
    loading: '로딩 중...',
    noData: '데이터가 없습니다',
    missingIds: '설비 ID 또는 금형 ID가 없습니다.',
    anomalySummary: '* 이상 점수: {score} | 임계값: {threshold} |',
    anomalyDetected: ' 이상 감지',
    anomalyNormal: ' 정상',
    importance: '중요도: {value}%',
    overallConfidence: '종합 신뢰도',
    lstmAccuracy: 'LSTM 예측 정확도',
    attentionConfidence: 'Attention 신뢰도',
    dataQuality: '데이터 품질 지수',
    radarNormal: '정상범위(±5%)',
    radarCurrent: '현재값',
    radarOptimal: '추천값',
    paramTrend: {
      cushion: '쿠션량 (mm)',
      cushionLabel: '쿠션량',
      nozzleTemp: '노즐온도 (°C)',
      nozzleTempLabel: '노즐온도',
      maxPress: '최대사출압력 (bar)',
      maxPressLabel: '최대사출압력',
    },
  },
  dynamicChart: {
    unsupported: '지원하지 않는 차트 타입입니다: {type}',
  },
  modal: {
    defaultTitle: '삭제 확인',
    defaultMessage: '정말 삭제하시겠습니까?',
    defaultConfirm: '삭제',
    defaultCancel: '취소',
  },
  tableRenderer: {
    noData: '테이블 데이터가 없습니다.',
    truncated: '* {displayed}개 행만 표시됨 (전체: {total}개)',
  },
  pagination: {
    info: '총 {total}개 중 {start}-{end}',
    sizeOption: '{n}개씩',
    first: '처음',
    previous: '이전',
    next: '다음',
    last: '마지막',
  },
};

export default components;
